import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { unit } from 'src/app/enum/units.enum';
import { AlertService } from 'src/app/services/alert-service.service';
import { FormChangeService } from 'src/app/services/form-change.service';
import { ParkingService } from 'src/app/services/parking.service';
import { StatsService } from 'src/app/stats/stats.service';
import { ZonesService } from 'src/app/zones/zones.service';

@Component({
  selector: 'app-form-min-dash',
  templateUrl: './form-min-dash.component.html',
  styleUrls: ['./form-min-dash.component.scss']
})
export class FormMinDashComponent implements OnInit, OnDestroy {
  dateRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  mySubscription : Subscription;
  @Input() installationId: any;
  searchText: string;
  model: NgModel;
  selectedTargetType = 'ZONE';
  targets;
  selectedTarget = new FormControl();
  units = [
    {id: 1, code:'HOURS', label: 'Heures'},
    {id: 2, code:'MINUTES', label: 'Minutes'},
    {id: 3, code:'DAYS', label: 'Jours'},
    {id: 4, code:'WEEKS', label: 'Semaines'},
    {id: 5, code:'MONTHS', label: 'Mois'},
    {id: 5, code:'YEARS', label: 'Années'},
  ];
  selectedUnite = 'HOURS';
  targetTypes = [
    {id: 1, code:'ZONE', label: 'Zones'},
    {id: 2, code:'PLACE', label: 'Places'}];
  constructor(
    private zoneServ: ZonesService,
    private placeServ: ParkingService,
    private formService: FormChangeService,
    private statsServ: StatsService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public router: Router) {
  }
  ngOnDestroy(): void {
    this.mySubscription.unsubscribe();
  }

  ngOnInit() {
    let start = moment().startOf('month');
    let end = moment().endOf('month');
    this.dateRange = new FormGroup({
      start: new FormControl(start.toDate()),
      end: new FormControl(end.toDate()),
    });
    this.getTargets(true);
    this.rechercherRealTimeStat();
    this.mySubscription= interval(120000).subscribe((x =>{
      this.rechercherRealTimeStat();
     }));
    
  }

  perimetreChange() {
    this.getTargets(false)
  }

  rechercher() {
    let data = {};
    let start = moment(this.dateRange.get('start').value).startOf('day');
    let end = moment(this.dateRange.get('end').value).endOf('day');
    let unitForDif;
    let maxDifForPerf;
    if(this.selectedUnite == "HOURS" ){
      maxDifForPerf = 24;
      unitForDif = "h";
    }
    if(this.selectedUnite =="MINUTES"){
      maxDifForPerf = 12;
      unitForDif = "m";
    }
    if(this.selectedUnite =="DAYS"){
      maxDifForPerf = 30;
      unitForDif = "d";
    }
    if(this.selectedUnite =="WEEKS"){
      maxDifForPerf = 7;
      unitForDif = "w";
    }
    if(this.selectedUnite =="MONTHS"){
      maxDifForPerf = 24;
      unitForDif = "M";
    }
    if(this.selectedUnite =="YEARS"){
      maxDifForPerf = 12;
      unitForDif = "y";
    }
    if(end.diff(start,unitForDif) > maxDifForPerf){
      this.alertService.error("pour des raison de performance, veillez fournir un intervale de recherche moins important,"
      +" maximum : " + maxDifForPerf + this.units.filter(el => el.code == this.selectedUnite)[0].label);
      return ;
    }
    data['target'] = this.selectedTargetType;
    data['targetIds'] = this.selectedTarget.value;
    data['timeFrom'] = start.format('DD/MM/yyyy HH:mm:ss');
    data['timeTo'] = end.format('DD/MM/yyyy HH:mm:ss');
    data['unitTime'] = this.selectedUnite;
    
    this.statsServ.getAdminStatsByArgs(data).subscribe(
      (data) => {
        this.formService.raiseDashStatSearch(data as Array<any>);
      },
      (error) =>{
        this.formService.raiseDashStatSearch([]);
      }
    );
  }

  rechercherRealTimeStat() {
    
    this.statsServ.getAdminStats().subscribe(
      (data) => {
        this.formService.raiseDashRealTimeStatSearch(data);
      },
      (error) =>{
        this.formService.raiseDashRealTimeStatSearch(null);
      }
    );
  }

  getTargets(search: boolean) {
    if(this.selectedTargetType == "ZONE"){
      this.zoneServ.getZones().subscribe(
        (data) =>{
          this.targets = data as Array<any>;
          this.selectedTarget.setValue(this.targets.map(el => el.id));
          
          if(search){
            // this.rechercher();  
          }

        }
      )
    }
    if(this.selectedTargetType == "PLACE"){
      this.placeServ.getMyPlacesById().subscribe(
        (data) =>{
          let places = data as Array<any>;
          places.forEach(el => {
            el.label = el.street + ', Place N° : '+ el.label;
          });
          this.targets = places;
          this.selectedTarget.setValue(this.targets.map(el => el.id));
          
          if(search){
            // this.rechercher();  
          }
        }
      )
    }
  }

}
